/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('UsageProduct_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceUsageProducts = $resource(baseUrl + 'rest/usageProducts/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
        return resourceUsageProducts;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('UsageProduct',["UsageProduct_Resource","ProductCategoryData","ProductData","UsageProductData","HumanResourceData","InternUsageProduct",
        function (UsageProduct_Resource,ProductCategoryData,ProductData,UsageProductData,HumanResourceData,InternUsageProduct)
    {
    //UsageProduct inherit from Activity
    var  UsageProduct = function (usageProductRes,isPreviousVersion)
    {
        this.id = null;
        this.upNumber = null;
        this.label = null;
        this.status = null;
        this.quantity = 0;
        this.product = null;
        this.description = null;
        this.product = null;
        this.humanResource = null;
        this.price = 0;
        this.product = null;
        this.timeCreated = new Date();
        this.version = null;
        this.internUsageProducts = [];

        if (usageProductRes !== undefined && usageProductRes != null)
        {
            this.loadObjectProperties(usageProductRes);
            this.loadObjectInternUsageProduct(usageProductRes);
        }
        if (isPreviousVersion == undefined || !isPreviousVersion)//A previous version is not added to DATA
            UsageProductData.add(this);
    };
        UsageProduct.prototype.loadObjectProperties = function(object)
        {
            if (object)
            {
                if (!this.id)
                    this.id = object.id;
                this.upNumber = object.upNumber;
                if (object.timeCreated)
                    this.timeCreated = new Date(object.timeCreated);
                this.status = object.status;
                this.price = object.price;
                this.description = object.description;
                this.billNumber = object.billNumber;
                if (object.stockDate)
                    this.stockDate = new Date(object.stockDate);
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.version)
                    this.version = object.version;
            }
        };

        UsageProduct.prototype.loadObject = function(object)
        {
            this.loadObjectProperties(object);
            this.loadObjectInternUsageProduct(object);
        };

        UsageProduct.prototype.loadRef = function(isPreviousVersion)
        {
            if (this.internUsageProducts)
                for (var i=0; i< this.internUsageProducts.length; i++)
                    this.internUsageProducts[i].loadRef();
        };

    UsageProduct.prototype.getObjectResource = function()
    {
        var usageProductRes = new UsageProduct_Resource();
        usageProductRes.id = this.id;
        usageProductRes.upNumber = this.upNumber;
        usageProductRes.price = this.price;
        usageProductRes.description = this.description;
        usageProductRes.status = this.status;
        usageProductRes.timeCreated = this.timeCreated;
        if (this.humanResource)
            usageProductRes.humanResourceId = this.humanResource.id;
        usageProductRes.internUsageProducts = [];
        for (var i=0;i< this.internUsageProducts.length;i++){
            usageProductRes.internUsageProducts.push(this.internUsageProducts[i].getObjectResource());
        }
        return usageProductRes;
    };

    UsageProduct.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
    };

    UsageProduct.prototype.setId = function(id)
    {
        this.id = id;
    };

    UsageProduct.prototype.getId = function()
    {
        return this.id;
    };

    UsageProduct.prototype.getLabel = function()
    {
        return this.label;
    };

    UsageProduct.prototype.getInternUsageProductById = function(id)
    {
        for (var i=0; i< this.internUsageProducts.length;i++)
            if (this.internUsageProducts[i].id == id)
                return this.internUsageProducts[i];
            return null;
        };

    UsageProduct.prototype.addInternUsageProduct = function(internUsageProduct)
    {
        var index =  this.internUsageProducts.indexOf(internUsageProduct);
        if (index == -1)
        {
            this.internUsageProducts.push(internUsageProduct);
            internUsageProduct.usageProduct = this;
        }
    };

        UsageProduct.prototype.loadObjectInternUsageProduct = function(object)
        {
            if (object.internUsageProducts)
            {
                this.internUsageProducts = [];//set to 0 and reload
                for (var i=0;i< object.internUsageProducts.length;i++)
                    this.addInternUsageProduct(new InternUsageProduct(object.internUsageProducts[i]));
            }

        };

    UsageProduct.prototype.removeInternUsageProduct = function(internUsageProduct)
    {
        if (internUsageProduct != null)
        {
            var index = this.internUsageProducts.indexOf(internUsageProduct);
            if (index != -1)
                this.internUsageProducts.splice(index,1);
            internUsageProduct.usageProduct = null;
        }

    };
    return UsageProduct;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('UsageProductSrv',["$log","ServerSrv","UsageProductData","UsageProduct","UserActionData","UsageProduct_Resource",
        function ($log,ServerSrv,UsageProductData,UsageProduct,UserActionData,UsageProduct_Resource)
    {
        var  bpSrv = {};
        bpSrv.loadRef = function()
        {
            var usageProducts = UsageProductData.indexUsageProducts;
            for (var i=0;i<usageProducts.length;i++)
                usageProducts[i].loadRef();
        };
        bpSrv.query = function(successFunction,errorFunction)
        {
            UsageProduct_Resource.query(
                {}, //params
                function (data) {   //success
                    UsageProductData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new UsageProduct(data[i],false);//Auto Add to UsageProductData
                    if (successFunction!== undefined)
                        successFunction(UsageProductData.getActiveList());

                },
                function (data) {   //failure
                    $log.error("UsageProduct_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        bpSrv.save =  function(usageProduct,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bpSrv.saveSync, usageProduct, successFunction, errorFunction);
        };
        bpSrv.saveSync =  function(usageProduct,successFunction,errorFunction)
        {
            //$timeout (function () {

            var upRes = usageProduct.getObjectResource();
            upRes.$save({}, //no params
                function (upRes) {
                 try {
                        usageProduct.id = upRes.id;
                        if (!usageProduct.version || (upRes.version && upRes.version > usageProduct.version))
                            usageProduct.version = upRes.version;
                        if (upRes.timeCreated)
                            usageProduct.timeCreated = new Date(upRes.timeCreated);


                        if (upRes.upNumber)
                            usageProduct.upNumber = upRes.upNumber;

                        for (var j = 0; j < usageProduct.internUsageProducts.length; j++)
                            usageProduct.internUsageProducts[j].setId(usageProduct.internUsageProducts[j].id);
                        //Add user action
                        UserActionData.add(upRes.userAction);
                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(upRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                }
            );

            //},2000)
        };
        bpSrv.updateLocally = function(id,resource)
        {
            //not specific code to manage update/remove from usageProduct because this link is change only for a add or delete
            // (a usageProduct can't be moved to another usageProduct)
            //return ActivitySrv.updateLocally(resource);
            //TODO
        };
        bpSrv.removeLocally = function(id,resource)
        {
            return UsageProductData.getById(id);
        };
        bpSrv.addLocally = function(id,resource)
        {
            var usageProduct = UsageProductData.getById(id)
            if (usageProduct && usageProduct.version && resource.version && resource.version < usageProduct.version)
                return null;

            if (usageProduct != null)
            {
                usageProduct.loadObjectProperties(resource);
            }
            else
            {
                usageProduct = new UsageProduct(resource,false,false);
                usageProduct.id = id;
            }
            usageProduct.loadRef();

            return usageProduct;
        };
        bpSrv.getPreviousVersionInstance = function(resource)
        {
            var usageProduct = new UsageProduct(resource,true);
            return usageProduct;

        };

        return bpSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('UsageProductData',["$log", function ($log)
    {
        var  usageProductData =
        {
            indexUsageProducts : []
        };
        usageProductData.getById =  function(usageProductId)
        {
            for (var i=0;i<this.indexUsageProducts.length;i++)
                if (this.indexUsageProducts[i].id == usageProductId)
                    return this.indexUsageProducts[i];
            return null;
        }
        usageProductData.getIndexOf = function(usageProduct)
        {
            if (usageProduct)
                return this.indexUsageProducts.indexOf(usageProduct);
            return -1;
        }
        usageProductData.getByIndex = function(index)
        {
            if (index>=0 && index < this.indexUsageProducts.length)
                return this.indexUsageProducts[index];
            else
                return null;
        }
        usageProductData.add = function(usageProduct)
        {
            this.indexUsageProducts.push(usageProduct);
            return this.indexUsageProducts.length-1;
        }
        usageProductData.clear = function()
        {
            usageProductData.indexUsageProducts = [];
        }
        usageProductData.getActiveList =  function()
        {
            return this.indexUsageProducts;
        }

        return usageProductData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/UsageProduct.js